// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jn-0";
export var animationContainer = "_jn-1";
export var itemPrice = "_jn-a";
export var itemizedContent = "_jn-9";
export var itemizedHeader = "_jn-7";
export var itemizedRow = "_jn-8";
export var itemizedSection = "_jn-6";
export var modalContent = "_jn-2";
export var orderName = "_jn-3";
export var refundOption = "_jn-4";
export var refundOptionsContainer = "_jn-5";
export var shippingLabel = "_jn-b";
export var totalRow = "_jn-c";